import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { INettingPrelevement } from 'src/app/shared/models/netting-prelevement';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { SnackbarService } from '../../../shared/services/snackbar.service';
import { ThemeService } from 'src/app/shared/services/theme.service';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { NettingPrelevementService } from '../netting-prelevement.service';
import * as fileSaver from 'file-saver';
import { ApplicationSettingsService } from '../../application-settings/application-settings.service';

@Component({
  selector: 'app-netting-prelevement-form-list',
  templateUrl: './netting-prelevement-form-list.component.html',
  styleUrls: ['./netting-prelevement-form-list.component.less']
})
export class NettingPrelevementFormListComponent implements OnInit, AfterViewInit {
  nettingsPrelevements!: MatTableDataSource<INettingPrelevement>;
  nettingPrelevementSelected!: INettingPrelevement;
  @ViewChild(MatSort)
  sort!: MatSort;
  displayedColumns: string[] = [
    'prelevement_name',
    'date_second_rate',
    'actions',
  ];
  apiUrl: any;
  http: any;
  constructor(
    private _npa: NettingPrelevementService,
    private snackbarService: SnackbarService,
    public authenticationService: AuthenticationService,
    private dialogService: DialogService,
    public theme: ThemeService,
    private applicationSettingsService: ApplicationSettingsService,
  ) {
    this.nettingsPrelevements = new MatTableDataSource();
  }


  openErrorSnackBar(message: string) {
    this.snackbarService.openSnackBar(message, 'error-snack-bar');
  }

  openSuccessSnackBar(message: string) {
    this.snackbarService.openSnackBar(message);
  }
  ngOnInit(): void {
    this.getNettingPrelevementService();
  }

  /**
   * Recupération de la liste des noms des prélèvements
   */
  getNettingPrelevementService() {
    this._npa.getNettingsPrelevements().subscribe(
      (data: INettingPrelevement[]) => {
        this.nettingsPrelevements.data = data;
      },
      (error) => {
        this.openErrorSnackBar(
          'Erreur lors de la récupération des prélèvements : ' +
          error.message,
        );
      },
    );
  }
  ngAfterViewInit() {
    this.nettingsPrelevements.sort = this.sort;
  }

  updateList(data: INettingPrelevement): void {
    this.getNettingPrelevementService();
  }

  /*
   * methode event for clear netting-form-list data
   */
  clearSelected() {
    this.nettingPrelevementSelected = {
      id: '',
      prelevement_name: '',
      date_second_rate: undefined,
      isEnabled: false
    };
  }

  filterList(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.nettingsPrelevements.filter = filterValue.trim().toLowerCase();
  }

  /*
   * edit netting-prelevement-form-data list using pencil icon
   */
  onEditRowPencel(row: INettingPrelevement): void {
    this.nettingPrelevementSelected = row;
    this.nettingPrelevementSelected.isEnabled = false;
  }

  /*
   * edit netting-prelevement-form-data list
   */
  onEditRow(row: INettingPrelevement): void {
    this.nettingPrelevementSelected = row;
    this.nettingPrelevementSelected.isEnabled = true;
  }

  onDeleteRow(row: INettingPrelevement) {
    this.dialogService.openConfirmDialog(row.prelevement_name).afterClosed().subscribe((res) => {
      if (res) {
        this._npa.deleteNettingsPrelevement(row).subscribe({
          next: () => {
            this.getNettingPrelevementService();
            this.clearSelected();
            this.openSuccessSnackBar('Le prélèvement a été supprimé avec succès');
          },
          error: (err) => {
            console.log(err);
            this.openErrorSnackBar(
              'Erreur lors de la suppression du Netting Prélèvement : ' +
              err.message,
            );
          },
        });
      }
    });
  }

  exportData() {
    this._npa.exportData().subscribe({
      next: (data) => {
        if (data) {
          const blob: any = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          window.URL.createObjectURL(blob);
          fileSaver.saveAs(
            blob,
            'Prélèvement Netting - ' +
            this.applicationSettingsService.applicationSettings.CDS_name +
            ' - ' +
            new Date().toLocaleDateString().replace('_', '-') +
            ' ' +
            new Date().toLocaleTimeString().replace('_', '-'),
          );
          this.openSuccessSnackBar('Prélèvements exporté avec succès');
        } else {
          this.openErrorSnackBar('Aucun Prélèvements a exporter');
        }
      },
      error: (err) => {
        console.log(err);
        this.openErrorSnackBar(
          "Une erreur est survenue lors de l'export ",
        );
      }
    });
  }

}
